// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061538/js/" + chunkId + "." + {"44":"e2553788","225":"728815f5","481":"3f17dcf2","486":"d0415481","770":"3411ef50"}[chunkId] + ".0.319098155706812.chunk.js";
};